module.exports = __webpack_public_path__ + "static/media/InPoker.8ff16701.svg";